const endpoints = [
  ["/now.md", "Canonical current brief in Markdown"],
  ["/now.json", "Canonical current claims with full citations"],
  ["/changes.json", "Append-only chronological change ledger"],
  ["/llms.txt", "LLM-readable map of Frontier State resources"],
  ["/api/context", "Bounded context packet for programmatic use"],
] as const;

export const MachineAccess = () => (
  <section className="section-block machine-section" aria-labelledby="machine-heading">
    <div className="section-heading">
      <div>
        <h2 id="machine-heading">Machine access</h2>
        <p>Stable, citation-carrying surfaces that do not require JavaScript.</p>
      </div>
      <a href="/llms.txt">Agent index <span aria-hidden="true">→</span></a>
    </div>
    <div className="endpoint-list">
      {endpoints.map(([path, description]) => (
        <a href={path} key={path}>
          <code>{path}</code>
          <span>{description}</span>
          <b>GET</b>
        </a>
      ))}
    </div>
  </section>
);

